/* eslint-disable no-shadow,no-param-reassign,no-mixed-operators */
import axios from 'axios';
import Vue from 'vue';

const state = {
  endpoint: 'api/web/clients',
  type: null,
  isExisting: false,
  companyFormItem: null,
  privateFormItem: {
    contacts: [],
    is_newsletter_recipient: false,
  },
  errors: {
    name: [],
    phone: [],
    email: [],
    code: [],
    type: [],
    vat_payer_code: [],
    address_street: [],
    address_nr: [],
    address_post_code: [],
    address_city: [],
    'contacts.0.email': [],
    'contacts.0.first_name': [],
    'contacts.0.last_name': [],
    'contacts.0.phone': [],
    'contacts.0.access': [],
  },
  loadingClients: false,
};

const getters = {};

const mutations = {
  storeType(state, type) {
    state.type = type;
  },

  storeCompany(state, client) {
    if (client) {
      state.companyFormItem = { ...client };
    } else {
      state.companyFormItem = {
        contacts: [{
          is_newsletter_recipient: false,
          access: 'unlimited',
        }],
      };
    }
    for (let i = 0; i < state.companyFormItem.contacts.length; i += 1) {
      state.errors[`contacts.${i}.email`] = [];
      state.errors[`contacts.${i}.first_name`] = [];
      state.errors[`contacts.${i}.last_name`] = [];
      state.errors[`contacts.${i}.phone`] = [];
      state.errors[`contacts.${i}.access`] = [];
    }
  },

  storePrivate(state, client) {
    state.privateFormItem = client || {
      contacts: [],
      is_newsletter_recipient: false,
    };
  },

  clearErrors(state, field) {
    state.errors[field] = [];
  },

  addContact(state) {
    state.companyFormItem.contacts.push({
      is_newsletter_recipient: false,
      type: 'other',
    });
    const index = state.companyFormItem.contacts.length - 1;
    state.errors[`contacts.${index}.email`] = [];
    state.errors[`contacts.${index}.first_name`] = [];
    state.errors[`contacts.${index}.last_name`] = [];
    state.errors[`contacts.${index}.phone`] = [];
    state.errors[`contacts.${index}.access`] = [];
  },

  removeContact(state, index) {
    state.companyFormItem.contacts.splice(index, 1);
    delete state.errors[`contacts.${index}.email`];
    delete state.errors[`contacts.${index}.first_name`];
    delete state.errors[`contacts.${index}.last_name`];
    delete state.errors[`contacts.${index}.phone`];
    delete state.errors[`contacts.${index}.access`];
  },

  created() {

  },

  setErrors(state, errors) {
    if (errors.response && errors.response.status === 422) {
      Object.keys(errors.response.data.errors).forEach((key) => {
        Vue.set(state.errors, key, errors.response.data.errors[key]);
      });
    }
  },

  setAddressFields(state, val) {
    if (state.type === 'company') {
      Vue.set(state.companyFormItem, 'address_street', val.street);
      Vue.set(state.companyFormItem, 'address_nr', val.number);
      Vue.set(state.companyFormItem, 'address_post_code', val.postCode);
      Vue.set(state.companyFormItem, 'address_city', val.city);
    } else {
      Vue.set(state.privateFormItem, 'address_street', val.street);
      Vue.set(state.privateFormItem, 'address_nr', val.number);
      Vue.set(state.privateFormItem, 'address_post_code', val.postCode);
      Vue.set(state.privateFormItem, 'address_city', val.city);
    }
  },

  storeManager(state, manager) {
    state.manager = manager;
  },

  setExistingClient(state, val) {
    state.isExisting = val;
  },
};

const actions = {
  find({ commit }, payload) {
    if (!payload || !payload.code) {
      commit('storeCompany');
      return Promise.resolve();
    }
    state.loadingClients = true;
    commit('setExistingClient', null);
    return new Promise((resolve, reject) => {
      axios.get(`api/client-details/${payload.code}`)
        .then((res) => {
          commit('setExistingClient', res.data.client_signed_contract);
          const c = res.data.company;
          if (c) {
            const company = {
              name: payload.name,
              address_street: c.street,
              address_nr: c.houseNo,
              address_post_code: c.postCode,
              address_city: c.city,
              code: c.code,
              phone: c.phone,
              email: c.email,
              contacts: [{
                is_newsletter_recipient: false,
                access: 'unlimited',
              }],
            };
            const m = res.data.manager;
            if (m) {
              company.contacts[0].type = 'manager';
              const firstNameEndIndex = m.VADOV.indexOf(' ');
              const positionIndex = m.VADOV.indexOf(',');
              if (firstNameEndIndex > -1 && positionIndex > -1) {
                let firstName = m.VADOV.slice(0, firstNameEndIndex).toLowerCase();
                let lastName = m.VADOV.slice(firstNameEndIndex + 1, positionIndex).toLowerCase();
                firstName = firstName.charAt(0).toUpperCase() + firstName.substr(1);
                lastName = lastName.charAt(0).toUpperCase() + lastName.substr(1);
                Vue.set(company.contacts[0], 'first_name', firstName);
                Vue.set(company.contacts[0], 'last_name', lastName);
              }
            }
            commit('storeCompany', company);
          } else {
            commit('storeCompany');
          }
          resolve(res);
        }).catch((err) => {
          commit('setExistingClient', null);
          reject(err);
        }).finally(() => {
          state.loadingClients = false;
        });
    });
  },

  createPrivate({ state, commit }) {
    state.privateFormItem.type = 'private';
    state.privateFormItem.name = `${state.privateFormItem.first_name} ${state.privateFormItem.last_name}`;
    return new Promise((resolve, reject) => {
      axios.put(state.endpoint, state.privateFormItem)
        .then((res) => {
          commit('created', res.data);
          resolve(res);
        }).catch((err) => {
          commit('setErrors', err);
          reject(err);
        });
    });
  },

  createCompany({ state, commit }) {
    if (state.companyFormItem.contacts[0].type === 'other') {
      // clients with type other can't authorize other employees
      state.companyFormItem.contacts = [state.companyFormItem.contacts[0]];
      state.companyFormItem.contacts[0].access = 'limited';
    } else {
      state.companyFormItem.contacts[0].access = 'unlimited';
    }
    state.companyFormItem.type = 'company';
    state.companyFormItem.is_newsletter_recipient = false;
    state.companyFormItem.phone = '--';
    return new Promise((resolve, reject) => {
      axios.put(state.endpoint, state.companyFormItem)
        .then((res) => {
          commit('created', res.data);
          resolve(res);
        }).catch((err) => {
          commit('setErrors', err);
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
